import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PilotPayHttpClient } from '../core';
import { IPilotPayVersion } from './pilotpay-version.types';
/**
 * PilotPayVersionService
 */
@Injectable()
export class PilotPayVersionService {
	constructor(http: PilotPayHttpClient) {
		this.http = http;
	}

	private http: PilotPayHttpClient;

	public getServerBuildVersion(): Observable<IPilotPayVersion> {
		return this.http.getRequest('/api/status/version');
	}
	public getServerTime(): Observable<string> {
		return this.http.getRequest('/api/status/time');
	}
}
